import { useEffect, useRef } from 'react';
import { useAppSelector, useAppDispatch } from '../../../store/app.hooks';
import {
  clearSlim360O365UserCopilotActivitySummary,
  slim360O365UserCopilotActivitySummarySelector,
} from '../../../store/slim360/o365UserCopilotActivitySummary/o365UserCopilotActivitySummary.reducer';
import { ISlim360O365UserCopilotActivitySummaryProps } from './o365UserCopilotActivitySummary.model';
import React from 'react';
import GlobalSearch from '../../../common/components/globalSearch/GlobalSearch';
import { useHistory } from 'react-router-dom';
import { Button } from 'antd';
import DeleteDatasetModal from '../../../common/components/DeleteDatasetModal';
import { Can } from '../../../common/ability';
import { Action, Page } from '../../../common/constants/pageAction';
import BreadCrumbs from '../../../common/components/Breadcrumbs';
import AddSlim360O365UserCopilotActivitySummaryModal from './AddO365UserCopilotActivitySummaryModal';
import MainTable from './MainTable';

const Slim360O365UserCopilotActivitySummary: React.FC<ISlim360O365UserCopilotActivitySummaryProps> =
  (props) => {
    const o365UserCopilotActivitySummary = useAppSelector(
      slim360O365UserCopilotActivitySummarySelector
    );
    const dispatch = useAppDispatch();
    const dataTableRef = useRef(null);
    const history = useHistory();

    const { id: urlId } = props.match?.params;

    const [addModalVisible, setAddModalVisible] = React.useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = React.useState(false);
    const [showSelectedListModal, setShowSelectedListModal] = React.useState(false);
    const [valuesForSelection, setValuesForSelection] = React.useState(null);

    const [id, setId] = React.useState(0);

    useEffect(() => {
      if (+urlId > 0) {
        setAddModalVisible(true);
        setId(+urlId);
      }
    }, [+urlId]);

    useEffect(() => {
      setShowSelectedListModal(false);
      return () => {
        dispatch(clearSlim360O365UserCopilotActivitySummary());
      };
    }, []);

    const refreshDataTable = () => {
      dataTableRef?.current.refreshData();
    };

    const tableButtons = () => (
      <>
        <Can I={Action.UpdateFromExcel} a={Page.Slim360O365UserCopilotActivitySummary}>
          <Button
            className="btn-icon"
            onClick={() =>
              history.push(
                `/data-input/bulk-update-from-excel/${encodeURIComponent(
                  o365UserCopilotActivitySummary.search.tableName
                )}`
              )
            }
            icon={
              <em className="anticon">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                  alt=""
                />
              </em>
            }
          >
            Update from Excel
          </Button>
        </Can>
        <Can I={Action.ImportToExcel} a={Page.Slim360O365UserCopilotActivitySummary}>
          <Button
            className="btn-icon"
            onClick={() =>
              history.push(
                `/data-input/bulk-import/${encodeURIComponent(
                  o365UserCopilotActivitySummary.search.tableName
                )}`
              )
            }
            icon={
              <em className="anticon">
                <img
                  src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                  alt=""
                />
              </em>
            }
          >
            Import
          </Button>
        </Can>
        <Can I={Action.DeleteData} a={Page.Slim360O365UserCopilotActivitySummary}>
          <Button
            className="btn-icon mr-1"
            onClick={() => setDeleteModalVisible(true)}
            disabled={o365UserCopilotActivitySummary.search.loading}
            icon={
              <em className="anticon">
                <img src={`${process.env.PUBLIC_URL}/assets/images/ic-delete.svg`} alt="" />
              </em>
            }
          >
            Delete Dataset
          </Button>
        </Can>
      </>
    );

    return (
      <div className="sqlServer">
        <div className="title-block">
          <h4 className="p-0">
            <BreadCrumbs pageName={Page.Slim360O365UserCopilotActivitySummary} />
          </h4>
          <div className="right-title">
            <GlobalSearch />
          </div>
        </div>
        <div className="main-card">
          {/* <div className="input-btns-title">
          <Row gutter={[10, 4]}>
            <Can I={Action.ImportToExcel} a={Page.Slim360O365UserCopilotActivitySummary}>
              <Col>
                <Button
                  className="btn-icon"
                  onClick={() =>
                    history.push(
                      `/data-input/bulk-import/${encodeURIComponent(
                        o365UserCopilotActivitySummary.search.tableName
                      )}`
                    )
                  }
                  icon={
                    <em className="anticon">
                      <img
                        src={`${process.env.PUBLIC_URL}/assets/images/ic-file-excel-outlined.svg`}
                        alt=""
                      />
                    </em>
                  }
                >
                  Import
                </Button>
              </Col>
            </Can>
          </Row>
        </div> */}
          <MainTable
            ref={dataTableRef}
            isMultiple={showSelectedListModal}
            setValuesForSelection={setValuesForSelection}
            setShowSelectedListModal={(state) => {
              setId(0);
              setShowSelectedListModal(state);
            }}
            setSelectedId={(id) => {
              setId(id);
              setAddModalVisible(true);
            }}
            tableButtons={tableButtons}
          />
        </div>
        {addModalVisible && (
          <AddSlim360O365UserCopilotActivitySummaryModal
            showModal={addModalVisible}
            isMultiple={false}
            handleModalClose={() => {
              setAddModalVisible(false);
              history.push('/slim360/slim360-o365-user-copilot-activity-summary');
            }}
            id={id}
            refreshDataTable={() => refreshDataTable()}
          />
        )}
        {showSelectedListModal && (
          <AddSlim360O365UserCopilotActivitySummaryModal
            showModal={showSelectedListModal}
            valuesForSelection={valuesForSelection}
            isMultiple={true}
            handleModalClose={() => {
              setShowSelectedListModal(false);
              history.push('/slim360/slim360-o365-user-copilot-activity-summary');
            }}
            id={id}
            refreshDataTable={() => refreshDataTable()}
          />
        )}
        {deleteModalVisible && (
          <DeleteDatasetModal
            showModal={deleteModalVisible}
            handleModalClose={() => setDeleteModalVisible(false)}
            tableName={o365UserCopilotActivitySummary.search.tableName}
            refreshDataTable={() => refreshDataTable()}
          />
        )}
      </div>
    );
  };

export default Slim360O365UserCopilotActivitySummary;
